import { gmiRequest } from 'actions/request';
import { actions, services } from '@ehi/global-marketing-interface';

export const cancelReservation = () => (dispatch, getState) => {
  const reservation = getState()?.getIn(['gmi', 'session', 'gbo', 'reservation']);
  const confirmation_number = reservation?.get('confirmation_number');

  return (
    confirmation_number &&
    dispatch(
      gmiRequest({
        action: actions.request({
          data: {
            payload: {
              confirmation_number,
              prepayModify: reservation?.get('prepay_selected'),
            },
          },
          service: services.gma.reservations.cancel,
        }),
        loadingOverlay: true,
      })
    )
  );
};
